import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { CardBody, CardImg, CardText, CardTitle, Col } from "reactstrap";
import { Card } from "reactstrap";
import { Row } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";

class ApplicationLargeForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  onGetOSType = type => {
    switch (type) {
      case "ANDROID":
        return (
          <i
            className="bx bxl-android font-size-22"
            style={{ color: "rgb(76,202,156)" }}
          />
        );
      case "IOS":
        return (
          <i
            className="bx bxl-apple font-size-22"
            style={{ color: "rgb(170,183,242)" }}
          />
        );
      default:
        return "";
    }
  };

  render() {
    return (
      <Link
        to={{
          pathname: `/${this.props.pathname}/${this.props.app_id}`,
          state: { app_name: this.props.name },
        }}
      >
        <CardStyled style={{ border: "1px solid rgba(0,0,0,0.1)" }}>
          <Row className="align-items-center">
            <Col md={2}>
              <StyledImage>
                {this.props.app_type === 1 ? (<CardImg
                  className="img-fluid"
                  src={this.props.image}
                  alt="Application"
                />) : (<StyledWWW>
                <span className="mdi mdi-web"></span>
                  WEBSITE
                </StyledWWW>)}

              </StyledImage>
            </Col>
            <Col md={10}>
              <CardBody
                style={{
                  padding: "15px 5px",
                }}
              >
                <CardTitle
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  className="h5"
                >
                  {this.props.name}
                </CardTitle>
                <CardText>
                  {this.props.description || "Descriptions is empty..."}
                </CardText>
                <CardText>
                  <small className="text-muted align-middle">
                    {this.onGetOSType(this.props.display_os_type)}
                  </small>
                </CardText>
              </CardBody>
            </Col>
          </Row>
        </CardStyled>
      </Link>
    );
  }
}

const StyledWWW = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #556ee6;
  justify-content: center;
  -webkit-box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
  color: #fff;
  font-size: 15px;

  span {
    font-size: 21px;
  }
`

const CardStyled = styled(Card)`
  transition-duration: 0.5s;
  &:hover {
    transition-duration: 0.5s;
    cursor: pointer;
    -webkit-box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.19);
    box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.1);
  }
`;

const StyledImage = styled.div`
  display: flex;
  justify-content: center;
  margin: 10% 10%;

  img {
    width: 80px;
    height: auto;
    border-radius: 15px;
    -webkit-box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
  }
`;

ApplicationLargeForm.propTypes = {
  data: PropTypes.any,
  image: PropTypes.any,
  app_id: PropTypes.any,
  description: PropTypes.any,
  name: PropTypes.any,
  display_os_type: PropTypes.any,
  history: PropTypes.any,
  pathname: PropTypes.string,
  app_type: PropTypes.node
};

export default withRouter(ApplicationLargeForm);
